<template>
  <div class="padres-container">

    <!-- VIDEO BACKGROUND -->
    <video
      class="video-fondo"
      autoplay
      muted
      loop
      playsinline
    >
      <source src="@/assets/vv1.mp4" type="video/mp4" />
    </video>

    <!-- Overlay for readability -->
    <div class="overlay-rosado"></div>

    <!-- COUNTasdasdasdasdasdasdasdasdasdDOWN -->
    <div ref="contadorRef" class="contador-container">
      <div class="rasgado rasgado-superior"></div>

      <br><br>

      <div class="frase-container">
        <h2 ref="fraseLinea1" class="frase linea1"> </h2>
        <h2 ref="fraseLinea2" class="frase linea2"></h2>
        <p ref="fraseLinea3" class="frase linea3"></p>
      </div>

      <div class="contador-titulo">
        <span ref="soloRef" class="solo">The Countdown </span>
        <span ref="faltanRef" class="faltan"></span>
      </div>

      <div ref="flechaRef" class="flecha-wrapper">
        <img src="@/assets/15.avif" alt="Decorative Arrow" class="flecha-img" />
      </div>

      <div class="contador-numeros">
        <div ref="tiempoRef1" class="tiempo">
          <span class="numero">{{ dias }}</span>
          <span class="etiqueta">Days</span>
        </div>

        <div ref="tiempoRef2" class="tiempo">
          <span class="numero">{{ horas }}</span>
          <span class="etiqueta">Hours</span>
        </div>

        <div ref="tiempoRef3" class="tiempo">
          <span class="numero">{{ minutos }}</span>
          <span class="etiqueta">Minutes</span>
        </div>

        <div ref="tiempoRef4" class="tiempo">
          <span class="numero">{{ segundos }}</span>
          <span class="etiqueta">Seconds</span>
        </div>

        <div class="rasgado rasgado-inferior"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const contadorRef = ref(null)
    const soloRef = ref(null)
    const faltanRef = ref(null)
    const flechaRef = ref(null)
    const tiempoRef1 = ref(null)
    const tiempoRef2 = ref(null)
    const tiempoRef3 = ref(null)
    const tiempoRef4 = ref(null)

    const dias = ref('00')
    const horas = ref('00')
    const minutos = ref('00')
    const segundos = ref('00')

    let timerId = null

    const cuentaAtras = () => {
      const evento = new Date('2026-11-07T18:30:00')
      const tick = () => {
        const ahora = new Date()
        const diferencia = evento - ahora
        if (diferencia <= 0) {
          dias.value = horas.value = minutos.value = segundos.value = '00'
          clearInterval(timerId)
          return
        }
        dias.value = String(Math.floor(diferencia / (1000 * 60 * 60 * 24))).padStart(2, '0')
        horas.value = String(Math.floor((diferencia / (1000 * 60 * 60)) % 24)).padStart(2, '0')
        minutos.value = String(Math.floor((diferencia / (1000 * 60)) % 60)).padStart(2, '0')
        segundos.value = String(Math.floor((diferencia / 1000) % 60)).padStart(2, '0')
      }
      tick()
      timerId = setInterval(tick, 1000)
    }

    onMounted(async () => {
      await nextTick()
      cuentaAtras()

      // ESTADO INICIAL
      gsap.set(contadorRef.value, { autoAlpha: 0, y: -80 })
      gsap.set([soloRef.value, faltanRef.value], { autoAlpha: 0, y: -40 })
      gsap.set(flechaRef.value, { autoAlpha: 0, y: -30, scale: 0.85 })
      gsap.set(
        [tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value],
        { autoAlpha: 0, y: -30 }
      )

      const el = contadorRef.value

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // Panel
          tl.to(el, {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: 'back.out(1.4)'
          })

          // Título
          tl.to(soloRef.value, {
            autoAlpha: 1,
            y: 0,
            duration: 0.6
          }, '>-0.3')

          tl.to(faltanRef.value, {
            autoAlpha: 1,
            y: 0,
            duration: 0.6
          }, '>-0.45')

          // Flecha
          tl.to(flechaRef.value, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.8,
            ease: 'back.out(1.6)'
          }, '>-0.2')

          // Contador
          tl.to(
            [tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value],
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.5,
              stagger: 0.12
            },
            '>-0.1'
          )

          // Animaciones vivas
          gsap.to(el, {
            scale: 1.01,
            duration: 3,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          })

          gsap.to(flechaRef.value, {
            y: '+=6',
            duration: 2,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut',
            delay: 0.5
          })

          io.disconnect()
        })
      }, { threshold: 0.35 })

      if (el) io.observe(el)
    })

    onUnmounted(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      contadorRef,
      soloRef,
      faltanRef,
      flechaRef,
      tiempoRef1,
      tiempoRef2,
      tiempoRef3,
      tiempoRef4,
      dias,
      horas,
      minutos,
      segundos
    }
  }
}
</script>


<style scoped>
/* =========================
   CONTENEDOR GENERAL
========================= */
.padres-container{
  position:relative;
  width:100%;
  min-height:40vh;
  display:flex;
  flex-direction:column;
  align-items:center;
  overflow:hidden;
  color:#312f2f !important;
}

/* =========================
   VIDEO DE FONDO
========================= */
.video-fondo{
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
  object-fit:cover;
  z-index:0;
}

/* =========================
   OVERLAY ROSADO
========================= */
.overlay-rosado{
  position:absolute;
  inset:0;
  z-index:1;
  background: rgba(246, 213, 229, 0.121);
}

/* =========================
   CONTENEDOR DEL CONTADOR
========================= */
.contador-container{
  position:relative;
  z-index:2;
  width:100%;
  max-width:600px;
  padding:26px 14px 34px;
  margin-top:20px;
  text-align:center;
  color:#ffffff !important;
  box-shadow:0 12px 32px rgba(0,0,0,.12);
  border-radius:8px;
  opacity:0;
  transform:translateY(50px);
}

/* =========================
   FRASE SUPERIOR (🔥 AQUÍ ESTABA EL ERROR)
========================= */
.frase{
  color:#ffffff !important;
  opacity:1 !important;
  text-shadow:none !important;
  mix-blend-mode:normal !important;
  filter:none !important;
}

.frase.linea1,
.frase.linea2{
  font-family:serif;
  font-size:26px;
}

.frase.linea3{
  font-family:serif;
  font-size:18px;
}

/* =========================
   TÍTULO SOLO / FALTAN
========================= */
.contador-titulo{
  margin-top:10px;
  margin-bottom:6px;
}

.contador-titulo .solo{
  font-family:'FeelingPassionate', cursive;
  font-size:42px;
  font-weight: 600;
  display:block;
  color:#ffffff !important;
  opacity:0;
}

.contador-titulo .faltan{
  font-family:serif;
  font-size:38px;
  letter-spacing:1px;
  display:block;
  color:#ffffff !important;
  opacity:0;
}

/* =========================
   FLECHA
========================= */
.flecha-wrapper{
  display:flex;
  justify-content:center;
  align-items:center;
  height:50px;
  padding-top:50px;
  margin:4px 0 10px;
}

.flecha-img{
  width:30px;
  height:auto;
  opacity:.95;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,.18));
}

/* =========================
   CONTADOR NUMÉRICO
========================= */
.contador-numeros{
  display:flex;
  justify-content:space-around;
  gap:10px;
  padding:4px 8px 12px;
}

.tiempo{
  display:flex;
  flex-direction:column;
  align-items:center;
  opacity:0;
  transform:translateY(50px);
}

.numero{
  font-size:40px;
  font-weight:bold;
  font-family:'Oswald', sans-serif;
  color:#ffffff;
}

.etiqueta{
  font-size:14px;
  font-family:'Oswald', sans-serif;
  margin-top:5px;
  color:#ffffff;
}

/* =========================
   RASGADOS
========================= */
.rasgado{
  position:absolute;
  left:0;
  width:100%;
  height:50px;
  background:#ffffff;
  z-index:3;
  margin-top:-40px;
  pointer-events:none;
}

.rasgado-superior{
  top:0;
  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}

.rasgado-inferior{
  bottom:0;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}

/* =========================
   RESPONSIVE
========================= */
@media (max-width:420px){
  .contador-numeros{ gap:6px; }
  .numero{ font-size:34px; }
}
/* =========================
   FIX DEFINITIVO iOS (Safari)
========================= */

/* Frases superiores */
.frase,
.frase * {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
  text-shadow: none !important;
  mix-blend-mode: normal !important;
}

/* SOLO / FALTAN */
.contador-titulo .solo,
.contador-titulo .faltan {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
  text-shadow: none !important;
  mix-blend-mode: normal !important;
}

/* NÚMEROS */
.numero,
.etiqueta {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
}

</style>
